module.exports = __webpack_public_path__ + "static/media/picto-paanteon-light-blue.adf250a0.svg";